/* Copyright Information: Created by BuyGroup */
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import React, { useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Moment from "react-moment";
import Select from "react-select";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Input, Row, Spinner, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Breadcrumbs from "../components/common/breadcrumb";
import { downloadInvoice, getOrderList, orderStatus } from "../services/OrderServices";
import {
  categoryList,
  getSubCategoryDetail,
} from "../services/ProductServices";
import "./Order.css";
import { generatePdfDocument } from "./OrderPDf";
import OrderUpdate from "./OrderUpdate";
import downloadIcon from "../assets/images/download-invoice.svg";
toast.configure();

const OrderList = (props) => {
  /* const SearchBar  responsible for serach */
  const { SearchBar } = Search;

  /* const "orderList" constant store all data of order List*/
  const [orderList, setOrderList] = useState([]);

  /* const "isloading" constant is responsible for showing loader in order List */
  const [isLoading, setIsLoading] = useState(false);

  /*  const "orderUpdateModal" responsible for order Update Modal open or closed  */
  const [orderUpdateModal, setOrderUpdateModal] = useState(false);

  /* const "isLoadingButton" constant is disable button when data is feaching from api */
  const [isLoadingButton, setIsLoadingButton] = useState(false);

  /* const "rowData"  store select Row data */
  const [rowData, setRowData] = useState({});

  const [lodingDownloadPdf, setLodingDownloadPdf] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState(null);

  const [categorys, setCategorys] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState(null);

  const [subCategorys, setSubCategorys] = useState([]);

  const [selectedSubCategory, setSelectedSubCategory] = useState(null);

  const [categoryId, setCategoryId] = useState("");

  const [subCategoryId, setSubCategoryId] = useState("");

  const [searchableGroupId, setSearchableGroupId] = useState("");

  const [searchableGroupValue, setSearchableGroupValue] = useState("");

  const [dateRangeValue, setDateRangeValue] = useState(null);

  const [loadingFilter, setLoadingFilter] = useState(false);

  const [hideFilters, setHideFilters] = useState(false);

  // Loading state for download invoice
  const [loadingOrderLineIdInvoice, setLoadingOrderLineIdInvoice] = useState(null);

  // New state variables for popup modal
  const [detailsModal, setDetailsModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalTitle, setModalTitle] = useState("");

  // Return reasons for better organization
  const returnReasons = [
    { value: "defective", label: "Product is defective or not working" },
    { value: "wrong_item", label: "Wrong item received" },
    { value: "not_as_described", label: "Product not as described" },
    { value: "damaged", label: "Product arrived damaged" },
    { value: "size_issue", label: "Size doesn't fit" },
    { value: "quality_issue", label: "Quality not as expected" },
    { value: "changed_mind", label: "Changed my mind" },
    { value: "duplicate_order", label: "Duplicate order" },
    { value: "missing_parts", label: "Missing parts or accessories" },
    { value: "expired", label: "Product expired or near expiry" },
    { value: "other", label: "Other reason" }
  ];

  const columns = [
    {
      dataField: "Order_id",
      text: "Order Id",
    },
    {
      dataField: "customer_name",
      text: "Name",
      headerAlign: "right",
      align: "right",
    },
    {
      dataField: "total",
      text: "Total Amount",
      headerAlign: "right",
      align: "right",
      formatter: priceFormatter,
    },
    {
      dataField: "Total_tax",
      text: "Tax Amount",
      headerAlign: "right",
      align: "right",
      formatter: priceFormatter,
    },
    {
      dataField: "Shipping_value",
      text: "Shipping Value",
      headerAlign: "right",
      align: "right",
      formatter: priceFormatter,
    },
    {
      dataField: "Status",
      text: "Status",
      headerAlign: "center",
      headerClasses: "header-classes-status_column",
      classes: "column-classes-status_column",
      align: "center",
      formatter: (cell, row) => {
        const availableTransitions = getAvailableStatuses(cell);
        const transitionText = availableTransitions.length > 0 
          ? `Available transitions: ${availableTransitions.map(s => getStatusDisplayName(s)).join(', ')}`
          : 'No further transitions available';
        
        return (
          <div className={`status_column ${cell}`}>
            <span title={transitionText}>{getStatusDisplayName(cell)}</span>
          </div>
        );
      },
    },
  ];

  const orderStatusList = [
    {
      label: "Pending",
      value: "in_progress",
    },
    {
      label: "To Be Shipped",
      value: "shipping",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "Cancelled",
      value: "cancelled",
      filterValue: (cell, row) => row,
    },
    {
      label: "Paid",
      value: "paid",
    },
    {
      label: "Payment Failed",
      value: "payment_failed",
    },
    {
      label: "Return Requested",
      value: "return_requested",
    },
    {
      label: "Return Accepted",
      value: "return_accepted",
    },
    {
      label: "Return Declined",
      value: "return_declined",
    },
    {
      label: "Return In Progress",
      value: "return_in_progress",
    },
    {
      label: "Refunded",
      value: "refunded",
    },
    {
      label: "Payment Captured",
      value: "payment_captured",
    },
    {
      label: "Amazon Submit Pending",
      value: "amazon_submit_pending",
    },
    {
      label: "Submitted to Amazon",
      value: "amazon_submitted",
    },
    {
      label: "Amazon Submit Failed",
      value: "amazon_submit_failed",
    },
  ];

  useEffect(() => {
    // setDateRangeValue([getstartDate(), new Date()]);
    getCategoryList();
    getOrder();
  }, []);

  useEffect(() => {
    if (categoryId) {
      getSubCategoryList(categoryId);
    }
  }, [categoryId]);

  /**
   * This function will return date of one month before
   * @returns
   */
  const getstartDate = () => {
    let date = new Date();
    date.setDate(date.getDate() - 30);
    return date;
  };

  /* it will formate number into two decimal number  */
  function priceFormatter(cell, row) {
    let myNumber = cell;
    let myNumberWithTwoDecimalPlaces = parseFloat(myNumber).toFixed(2);
    return myNumberWithTwoDecimalPlaces;
  }

  // Define the status flow - what statuses can transition to what
  const getAvailableStatuses = (currentStatus) => {
    console.log("currentStatus", currentStatus);
    const statusFlow = {
      // Regular order flow
      in_progress: ["shipping", "cancelled", "payment_failed"],
      shipping: ["completed", "cancelled", "payment_failed"],
      completed: ["return_requested", "refunded"],
      cancelled: [],
      paid: ["completed", "cancelled", "shipping"],
      payment_failed: [],
      
      // Return flow
      return_requested: ["return_accepted", "return_declined"],
      return_accepted: ["return_in_progress"],
      return_declined: [],
      return_in_progress: ["refunded"],
      refunded: [],
      order_placed: ["completed", "cancelled", "shipping"],
      payment_captured: [],
      amazon_submit_pending: [],
      amazon_submitted: ["completed", "cancelled", "shipping"],
      amazon_submit_failed: [],
    };

    return statusFlow[currentStatus] || [];
  };

  // Get status display name
  const getStatusDisplayName = (status) => {
    const statusNames = {
      in_progress: "In Progress",
      shipping: "To Be Shipped",
      completed: "Completed",
      cancelled: "Cancelled",
      paid: "Paid",
      payment_failed: "Payment Failed",
      return_requested: "Return Requested",
      return_accepted: "Return Accepted",
      return_declined: "Return Declined",
      return_in_progress: "Return In Progress",
      refunded: "Refunded",
      return_label_sent: "Return Label Sent",
      order_placed: "Order Placed",
      payment_captured: "Payment Captured",
      amazon_submit_pending: "Amazon Submit Pending",
      amazon_submitted: "Submitted to Amazon",
      amazon_submit_failed: "Amazon Submit Failed",
    };
    return statusNames[status] || status;
  };

  /**
   * This funciton will formate start date of date formator in yyyy-mm-dd formate
   * @param {array} dateRangeValue
   * @returns
   */
  const formatStartDate = (dateRangeValue) => {
    if (dateRangeValue !== null) {
      if (dateRangeValue.length > 1) {
        return moment(dateRangeValue[0]).format("YYYY-MM-DD");
      }
      return moment(getstartDate()).format("YYYY-MM-DD");
    }
    return null;
  };

  /**
   * This funciton will formate end date of date formator in yyyy-mm-dd formate
   * @param {array} dateRangeValue
   * @returns
   */

  const formatEndDate = (dateRangeValue) => {
    if (dateRangeValue !== null) {
      if (dateRangeValue.length > 1) {
        return moment(dateRangeValue[1]).format("YYYY-MM-DD");
      }
      return moment(new Date()).format("YYYY-MM-DD");
    }
    return null;
  };

  /**
   * This function will handle status value
   * @param {object} selectedStatus
   * @returns
   */
  const handleStatus = (selectedStatus) => {
    if (selectedStatus) {
      return selectedStatus.value;
    }
    return "";
  };

  // Get all order list from API
  const getOrder = () => {
    setIsLoading(true);
    setLoadingFilter(true);
    const prpareData = {
      status: handleStatus(selectedStatus),
      group_name: searchableGroupValue,
      range_start: formatStartDate(dateRangeValue),
      range_end: formatEndDate(dateRangeValue),
      group_id: searchableGroupId,
      category_id: categoryId,
      sub_category_id: subCategoryId,
    };

    getOrderList(prpareData)
      .then((res) => {
        if (res.status === 200) {
          setOrderList(res.data);
          setIsLoading(false);
          setLoadingFilter(false);
          setHideFilters(true);
        }
      })
      .catch((error) => {
        toast.error(error.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setIsLoading(false);
        setLoadingFilter(false);
        setHideFilters(true);
      });
  };

  /**
   * Function handleModalOpen open update order modal
   * @param {row} row data object
   */

  const handleModalOpen = (orderSubRow, index) => {
    console.log("orderSubRow", orderSubRow);
    setRowData(orderSubRow);
    setOrderUpdateModal(true);
  };

  /**
   * Function to open details modal for amazon_order_failed_reason and amazon_order_details
   * @param {object} orderSubRow order data
   */
  const handleFailedReasonModal = (orderSubRow) => {
    setModalTitle("Order Details");
    setModalData({
      failed_reason: orderSubRow.amazon_order_failed_reason,
      amazon_details_input: orderSubRow.amazon_order_details_input,
      amazon_details_output: orderSubRow.amazon_order_details_output
    });
    setDetailsModal(true);
  };

  /**
   * Function to open return requested modal for return reason and note
   * @param {object} orderSubRow order data
   */
  const handleReturnRequestedModal = (orderSubRow) => {
    setModalTitle("Return Request Details");
    setModalData({
      return_reason: orderSubRow.return_reason,
      return_note: orderSubRow.customer_return_note,
      status: orderSubRow.status
    });
    setDetailsModal(true);
  };

  /**
   * Function to close details modal
   */
  const closeDetailsModal = () => {
    setDetailsModal(false);
    setModalData({});
    setModalTitle("");
  };

  /**
   * Function updateOrder update order status and API calling
   *@param {values} values data object
   */
  const updateOrder = (values, actions) => {
    setIsLoadingButton(true);
    orderStatus(values)
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          setIsLoadingButton(false);
          setOrderUpdateModal(false);
          getOrder();
        }
      })
      .catch((error) => {
        toast.error(error.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setIsLoadingButton(false);
      });
  };

  const handleLodingDownloadPdf = (value) => {
    setLodingDownloadPdf(value);
  };

  /**
   * This function will handle category selection
   * @param {object} selectedCategory
   */
  const handleChangeCategory = (selectedCategory) => {
    const categoryId = selectedCategory ? selectedCategory.value : "";
    setSelectedCategory(selectedCategory);
    setCategoryId(categoryId);
  };

  /**
   * This function will handle sub category selection
   * @param {object} selectedSubCategory
   */
  const handleSubChangeCategory = (selectedSubCategory) => {
    const subCategoryId = selectedSubCategory ? selectedSubCategory.value : "";
    setSelectedSubCategory(selectedSubCategory);
    setSubCategoryId(subCategoryId);
  };

  /*
   * Function getAllCategory get all the data for categories
   */

  const getCategoryList = () => {
    categoryList()
      .then((res) => {
        if (res.status === 200) {
          let options = res.data.map(function (cat) {
            return { value: cat.category_id, label: cat.category_name };
          });
          setCategorys(options);
        }
      })
      .catch((error) => {
        setCategorys([]);
        toast.error(error.data?.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
      });
  };

  /**
   * This function will give sub category of respected categoryId
   * @param {string} categoryId
   */
  const getSubCategoryList = (categoryId) => {
    if (categoryId) {
      getSubCategoryDetail(categoryId)
        .then((res) => {
          if (res?.status === 200) {
            let options = res.data.map(function (cat) {
              return { value: cat.id, label: cat.category };
            });
            setSubCategorys(options);
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  };

  const canUpdateOrderLineStatus = (orderSubRow) => {
    if (orderSubRow.can_update_status !== undefined) {
      return orderSubRow.can_update_status === true;
    }

    return !["payment_failed", "amazon_submit_failed"].includes(orderSubRow.status);
  };

  /**
   * Function to download invoice
   */
  const handleDownloadInvoice = (orderLineId) => {
    console.log("orderLineId", orderLineId);
    setLoadingOrderLineIdInvoice(orderLineId);
    downloadInvoice(orderLineId)
      .then((res) => {
        // Create buffer from base64 string
        const binary = Buffer.from(res, "base64");
        const blob = new Blob([binary], { type: "application/pdf" });
        // Create download link
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Invoice.pdf";
        link.click();
        URL.revokeObjectURL(url);

        toast.success("Invoice PDF downloaded successfully", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      })
      .catch((error) => {
        toast.error("Failed to download invoice", {
          autoClose: 3000,
          hideProgressBar: true,
        });
      })
      .finally(() => {
        setLoadingOrderLineIdInvoice(null);
      });
  };

  const expandRow = {
    renderer: (orderRow) => (
      <div className="innerSubCategory">
        <table className="table">
          <tr>
            <th>Image</th>
            <th>Group Id</th>
            <th>Group Name</th>
            <th>Category</th>
            <th>Sub Category</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Quantity</th>
            <th>Rate</th>
            <th>Supplier</th>
            <th>Status</th>
            <th>Amazon Product</th>
            <th>Amazon Order ID</th>
          </tr>

          {orderRow.order_lines.length > 0 ? (
            orderRow.order_lines.map((orderSubRow, index) => {
              return (
                <tr key={orderSubRow.order_line_id}>
                  <td>
                    <div className="product_thumb">
                      <img
                        alt="Not Found"
                        className="img-responsive"
                        src={orderSubRow.path}
                      />
                    </div>
                  </td>
                  <td>{orderSubRow.group_id}</td>
                  <td>{orderSubRow.group_name}</td>
                  <td>{orderSubRow.category}</td>
                  <td>{orderSubRow.sub_category}</td>
                  <td>
                    <Moment format="MM/DD/YYYY h:mm a">
                      {orderSubRow.start_date}
                    </Moment>
                  </td>
                  <td>
                    <Moment format="MM/DD/YYYY h:mm a">
                      {orderSubRow.end_date}
                    </Moment>
                  </td>
                  <td>{orderSubRow.quantity}</td>
                  <td>${parseFloat(orderSubRow.rate).toFixed(2)}</td>
                  <td>{orderSubRow.company_name}</td>
                  <td>
                    <div className={`status_column ${orderSubRow.status}`}>
                      <span>{getStatusDisplayName(orderSubRow.status)}</span>
                      {orderSubRow.status === "cancelled" &&
                        (orderSubRow.amazon_order_failed_reason ||
                          orderSubRow.amazon_order_details_input ||
                          orderSubRow.amazon_order_details_output) && (
                          <>
                            <i
                              className="fa fa-info-circle ml-1"
                              style={{
                                cursor: "pointer",
                                color: "#ff6b6b",
                                fontSize: "16px",
                              }}
                              onClick={() =>
                                handleFailedReasonModal(orderSubRow)
                              }
                              title={
                                orderSubRow.amazon_order_failed_reason ||
                                "Click to view order details"
                              }
                            ></i>
                          </>
                        )}
                      {orderSubRow.status === "return_requested" &&
                        (orderSubRow.return_reason ||
                          orderSubRow.return_note) && (
                          <>
                            <i
                              className="fa fa-info-circle ml-1"
                              style={{
                                cursor: "pointer",
                                color: "#ff6b6b",
                                fontSize: "16px",
                              }}
                              onClick={() =>
                                handleReturnRequestedModal(orderSubRow)
                              }
                              title={
                                orderSubRow.return_reason ||
                                "Click to view return details"
                              }
                            ></i>
                          </>
                        )}
                    </div>
                  </td>
                  <td>{orderSubRow.is_amazon_product ? "Yes" : "No"}</td>
                  <td>{orderSubRow.amazon_order_id || ""}</td>
                  <td>
                    <span
                      className={`inline-block ${canUpdateOrderLineStatus(orderSubRow) ? "pointer-cursor" : ""}`}
                      onClick={() => {
                        if (canUpdateOrderLineStatus(orderSubRow)) {
                          handleModalOpen(orderSubRow, index);
                        }
                      }}
                      title={
                        canUpdateOrderLineStatus(orderSubRow)
                          ? "Update order status"
                          : "Failed order lines cannot be updated from admin"
                      }
                    >
                      <i
                        className="fa fa-pencil"
                        style={{
                          width: 35,
                          fontSize: 20,
                          padding: 11,
                          color: "#e4566e",
                          cursor: canUpdateOrderLineStatus(orderSubRow) ? "pointer" : "not-allowed",
                          opacity: canUpdateOrderLineStatus(orderSubRow) ? 1 : 0.45,
                        }}
                      ></i>
                    </span>
                  </td>
                  {orderSubRow.can_download_invoice && (
                    <td>
                      <button
                        title="Download Invoice"
                        className="btn orderlineitem-btn"
                        onClick={() =>
                          handleDownloadInvoice(orderSubRow.order_line_id)
                        }
                        disabled={
                          loadingOrderLineIdInvoice ===
                          orderSubRow.order_line_id
                        }
                      >
                        {loadingOrderLineIdInvoice ===
                        orderSubRow.order_line_id ? (
                          <Spinner size="md" />
                        ) : (
                          <img src={downloadIcon} alt="download" />
                        )}
                      </button>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <td>No Data Found</td>
          )}
        </table>
      </div>
    ),
    onlyOneExpanding: true,
  };

  const applyFilter = () => {
    getOrder();
  };

  return (
    <>
      <Breadcrumbs title="Orders" parent="" subtitle="Orders Admin Panel" />
      <div className="container-fluid">
        <Row className="row">
          <Col md="12">
            <React.Fragment>
              <Row>
                <Col lg="12" md="12">
                  <Card className="card-box">
                    <CardBody>
                      <ToolkitProvider
                        keyField="Order_id"
                        data={orderList}
                        columns={columns}
                        search
                      >
                        {(props) => (
                          <>
                            <div className="order-header d-flex align-items-center flex-wrap justify-content-between">
                              <h5>Orders</h5>
                              <Button
                                type="button"
                                color="secondary"
                                data-toggle="modal"
                                data-original-title="Download pdf"
                                onClick={() =>
                                  generatePdfDocument(
                                    orderList,
                                    handleLodingDownloadPdf
                                  )
                                }
                                disabled={lodingDownloadPdf || isLoading}
                              >
                                <i className="fa fa-download mr-2"></i>
                                {lodingDownloadPdf ? (
                                  <>
                                    <Spinner size="sm" /> Download... Pdf
                                  </>
                                ) : (
                                  "Download Pdf"
                                )}
                              </Button>
                            </div>
                            {hideFilters && (
                              <div className="select_dropdown">
                                <Row className="table_SearchBar">
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  >
                                    <Select
                                      value={selectedStatus}
                                      onChange={(value) =>
                                        setSelectedStatus(value)
                                      }
                                      options={orderStatusList}
                                      isClearable={true}
                                      placeholder="Filter By Status"
                                    />
                                  </Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  >
                                    <Select
                                      value={selectedCategory}
                                      onChange={handleChangeCategory}
                                      options={categorys}
                                      isClearable={true}
                                      placeholder="Filter By Category"
                                    />
                                  </Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  >
                                    <Select
                                      value={selectedSubCategory}
                                      onChange={handleSubChangeCategory}
                                      options={subCategorys}
                                      isClearable={true}
                                      placeholder="Filter By Sub Category"
                                    />
                                  </Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  >
                                    <Input
                                      type="search"
                                      value={searchableGroupValue}
                                      onChange={(e) =>
                                        setSearchableGroupValue(e.target.value)
                                      }
                                      placeholder="Search Group"
                                    />
                                  </Col>
                                </Row>
                                <Row className="filter-container">
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  >
                                    <Input
                                      type="number"
                                      value={searchableGroupId}
                                      onChange={(e) =>
                                        setSearchableGroupId(e.target.value)
                                      }
                                      placeholder="Search Group by Id"
                                      min="0"
                                    />
                                  </Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  >
                                    <DateRangePicker
                                      onChange={(dates) => {
                                        console.log("dates", dates);
                                        setDateRangeValue(dates);
                                      }}
                                      value={dateRangeValue}
                                      rangeDivider="to"
                                    />
                                  </Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col"
                                  ></Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={6}
                                    xs={12}
                                    className="filter-container-col d-flex justify-content-end align-items-center"
                                  >
                                    {" "}
                                    <Button
                                      type="submit"
                                      color="primary"
                                      onClick={applyFilter}
                                      disabled={loadingFilter}
                                    >
                                      {loadingFilter ? "Apply..." : "Apply"}
                                    </Button>
                                  </Col>
                                </Row>
                              </div>
                            )}

                            {isLoading ? (
                              <div className="custom-loader">
                                <Spinner animation="border" />
                              </div>
                            ) : (
                              <>
                                <BootstrapTable
                                  {...props.baseProps}
                                  striped
                                  hover
                                  id="pdftable"
                                  condensed
                                  noDataIndication={"No order found"}
                                  bordered={false}
                                  expandRow={expandRow}
                                  pagination={paginationFactory({
                                    sizePerPage: 10,
                                    showTotal: true,
                                    hideSizePerPage: true,
                                  })}
                                  rowClasses="row-hover pointer-cursor"
                                />
                              </>
                            )}
                          </>
                        )}
                      </ToolkitProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </React.Fragment>
          </Col>
        </Row>
      </div>
      {orderUpdateModal && (
        <OrderUpdate
          orderUpdateModal={orderUpdateModal}
          onSubmit={updateOrder}
          isLoadingButton={isLoadingButton}
          rowData={rowData}
          handleModalClose={() => setOrderUpdateModal(false)}
        />
      )}
      
      {/* Details Modal */}
      <Modal isOpen={detailsModal} toggle={closeDetailsModal} size="lg" style={{ maxHeight: '90vh' }}>
        <ModalHeader toggle={closeDetailsModal}>
          {modalTitle}
        </ModalHeader>
        <ModalBody style={{ maxHeight: 'calc(90vh - 140px)', overflow: 'auto' }}>
          {modalData.failed_reason && (
            <div className="mb-4">
              <h6>Failed Reason:</h6>
              <p className="text-danger">{modalData.failed_reason}</p>
            </div>
          )}
          {modalData.return_reason && (
            <div className="mb-4">
              <h6>Return Reason:</h6>
              <p className="text-muted">
                {returnReasons.find(reason => reason.value === modalData.return_reason)?.label || modalData.return_reason}
              </p>
            </div>
          )}
          {modalData.return_note && (
            <div className="mb-4">
              <h6>Return Note:</h6>
              <p className="text-muted">{modalData.return_note}</p>
            </div>
          )}
          {modalData.amazon_details_input && (
            <div className="mb-4">
              <h6>Amazon Order Details Input:</h6>
              <pre style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '15px', 
                borderRadius: '5px',
                maxHeight: '300px',
                overflow: 'auto',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word'
              }}>
                {typeof modalData.amazon_details_input === 'object' 
                  ? JSON.stringify(modalData.amazon_details_input, null, 2)
                  : modalData.amazon_details_input
                }
              </pre>
            </div>
          )}
          {modalData.amazon_details_output && (
            <div>
              <h6>Amazon Order Details Output:</h6>
              <pre style={{ 
                backgroundColor: '#f8f9fa', 
                padding: '15px', 
                borderRadius: '5px',
                maxHeight: '300px',
                overflow: 'auto',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word'
              }}>
                {typeof modalData.amazon_details_output === 'object' 
                  ? JSON.stringify(modalData.amazon_details_output, null, 2)
                  : modalData.amazon_details_output
                }
              </pre>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeDetailsModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
export default OrderList;
/* Copyright Information: Created by BuyGroup */
